module.exports = __webpack_public_path__ + "img/tutorial_course_01.46a19f1b.gif";